"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@icare/components/lib/Button"));

var _Message = _interopRequireDefault(require("@icare/components/lib/Message"));

var _Spinner = _interopRequireDefault(require("@icare/components/lib/Spinner"));

var _Form = _interopRequireDefault(require("@icare/forms/lib/models/Form"));

var _GenericForm = _interopRequireDefault(require("@icare/forms/lib/components/GenericForm"));

var _FormErrorSummary = _interopRequireDefault(require("@icare/forms/lib/components/FormErrorSummary"));

var _LayoutField = _interopRequireDefault(require("@icare/forms/lib/components/LayoutField"));

var _IdentityService = _interopRequireDefault(require("../services/IdentityService"));

var _IdentityUtils = _interopRequireDefault(require("../utils/IdentityUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var forgotEntity = {
  id: "forgotPasswordForm",
  sections: [{
    id: "forgotPasswordForm",
    fields: [{
      id: "Username",
      label: "Email address",
      type: "email",
      validators: [{
        type: "isEmail"
      }],
      required: true,
      requiredMessage: "Please enter your email address."
    }, {
      id: "Firstname",
      label: "First Name",
      type: "text",
      required: true,
      requiredMessage: "Please enter your first name."
    }, {
      id: "Lastname",
      label: "Last Name",
      type: "text",
      required: true,
      requiredMessage: "Please enter your last name."
    }, {
      id: "Useremail",
      label: "Email address",
      type: "text"
    }]
  }]
};
var errorDetailsMsg = {
  RECOVERY_CREDENTIAL_NOT_SET: 'Recovery credential not set.' // is thrown when Secret Q&A not set

};
/**
 * Okta login form
 */

var ForgotPasswordForm = /*#__PURE__*/function (_React$Component) {
  _inherits(ForgotPasswordForm, _React$Component);

  var _super = _createSuper(ForgotPasswordForm);

  //region Properties
  //endregion
  //region Lifecycle
  function ForgotPasswordForm(props) {
    var _this;

    _classCallCheck(this, ForgotPasswordForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_handleSubmit", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
        var _this$props, oktaEnv, portalIdentifier, successMessage, unknownUserRecoveryErrorMessage, errMessages, triggerSecretQuestionForm, successMessageSecretQuestion, _this$state, form, showPasswordRecoveryForm, _showPasswordRecoveryForm, oktaMessage, foundErrMsg;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //this.props.onWillLogin(values);
                _this$props = _this.props, oktaEnv = _this$props.oktaEnv, portalIdentifier = _this$props.portalIdentifier, successMessage = _this$props.successMessage, unknownUserRecoveryErrorMessage = _this$props.unknownUserRecoveryErrorMessage, errMessages = _this$props.errMessages, triggerSecretQuestionForm = _this$props.triggerSecretQuestionForm, successMessageSecretQuestion = _this$props.successMessageSecretQuestion;
                _this$state = _this.state, form = _this$state.form, showPasswordRecoveryForm = _this$state.showPasswordRecoveryForm;

                _this.setState({
                  isBusy: true,
                  oktaMessage: null
                });

                if (!(triggerSecretQuestionForm && showPasswordRecoveryForm)) {
                  _context.next = 15;
                  break;
                }

                _context.prev = 4;
                _context.next = 7;
                return _this._service.submitSecretQuestionForm(values.forgotPasswordForm__Firstname, values.forgotPasswordForm__Lastname, values.forgotPasswordForm__Useremail);

              case 7:
                _this.setState({
                  successfullTransaction: true,
                  isBusy: false,
                  oktaMessage: {
                    type: _Message.default.type.SUCCESS,
                    title: null,
                    body: successMessageSecretQuestion
                  },
                  showPasswordRecoveryForm: false
                }, function () {
                  form.fields.get('forgotPasswordForm__Username').set('disabled', true);
                });

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](4);

                _this.setState({
                  successfullTransaction: false,
                  isBusy: false,
                  oktaMessage: {
                    type: _Message.default.type.ERROR,
                    title: null,
                    body: 'Something went wrong please try again later.'
                  },
                  showPasswordRecoveryForm: false
                });

              case 13:
                _context.next = 28;
                break;

              case 15:
                _context.prev = 15;
                _context.next = 18;
                return _this._service.recoverPassword(values.forgotPasswordForm__Username, oktaEnv, portalIdentifier);

              case 18:
                _this.setState({
                  successfullTransaction: true,
                  isBusy: false,
                  oktaMessage: {
                    type: _Message.default.type.SUCCESS,
                    title: null,
                    body: successMessage
                  }
                }, function () {
                  form.fields.get('forgotPasswordForm__Username').set('disabled', true);
                });

                _context.next = 28;
                break;

              case 21:
                _context.prev = 21;
                _context.t1 = _context["catch"](15);
                _showPasswordRecoveryForm = false;
                oktaMessage = _IdentityUtils.default.getErrorDetails(_context.t1.innerErrors);

                if (oktaMessage.title === 'UnknownUserRecovery') {
                  oktaMessage.title = unknownUserRecoveryErrorMessage.title;
                  oktaMessage.body = /*#__PURE__*/_react.default.createElement("p", {
                    dangerouslySetInnerHTML: {
                      __html: unknownUserRecoveryErrorMessage.text
                    }
                  });
                } else if (Array.isArray(errMessages) && errMessages.length > 0) {
                  foundErrMsg = '';

                  if (triggerSecretQuestionForm && oktaMessage.detail === errorDetailsMsg.RECOVERY_CREDENTIAL_NOT_SET) {
                    foundErrMsg = errMessages.find(function (err) {
                      return err.errDetail === oktaMessage.detail;
                    });
                    _showPasswordRecoveryForm = true;
                  } else {
                    foundErrMsg = errMessages.find(function (err) {
                      return err.errTitle === oktaMessage.title;
                    });
                  }

                  if (foundErrMsg) {
                    oktaMessage.type = 'is-error';
                    oktaMessage.title = foundErrMsg.errTitle;
                    oktaMessage.body = /*#__PURE__*/_react.default.createElement("p", {
                      dangerouslySetInnerHTML: {
                        __html: foundErrMsg.errMessage
                      }
                    });
                  }
                }

                _this.setState({
                  successfullTransaction: false,
                  isBusy: false,
                  oktaMessage: oktaMessage,
                  showPasswordRecoveryForm: _showPasswordRecoveryForm
                }, function () {
                  _showPasswordRecoveryForm && form.fields.get('forgotPasswordForm__Useremail').set(form.fields.get('forgotPasswordForm__Username').value);
                });

                if (_context.t1.name !== 'APIError') {
                  console.error(_context.t1);
                }

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 10], [15, 21]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "_renderGenericFormForPasswordRecovery", function () {
      var form = _this.state.form;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "Firstname",
        sectionId: "forgotPasswordForm"
      }), /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "Lastname",
        sectionId: "forgotPasswordForm"
      }), /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "Useremail",
        sectionId: "forgotPasswordForm",
        disabled: true
      }));
    });

    _this._service = new _IdentityService.default(props.identityBaseUrl);
    _this.state = {
      isBusy: false,
      form: _Form.default.initialiseFromConfig(props.onInitilise(forgotEntity)),
      oktaMessage: null,
      successfullTransaction: false // Used to hide buttons BR # 6

    };
    return _this;
  } //endregion
  //region Methods

  /**
   * Login form submit handler
   * @param values
   * @private
   */


  _createClass(ForgotPasswordForm, [{
    key: "render",
    //region Render Methods
    value: function render() {
      var _this$props2 = this.props,
          additionalButtons = _this$props2.additionalButtons,
          submitBtnText = _this$props2.submitBtnText,
          triggerSecretQuestionForm = _this$props2.triggerSecretQuestionForm;
      var _this$state2 = this.state,
          form = _this$state2.form,
          oktaMessage = _this$state2.oktaMessage,
          successfullTransaction = _this$state2.successfullTransaction,
          isBusy = _this$state2.isBusy,
          showPasswordRecoveryForm = _this$state2.showPasswordRecoveryForm;
      return /*#__PURE__*/_react.default.createElement(_Spinner.default, {
        active: isBusy
      }, /*#__PURE__*/_react.default.createElement(_GenericForm.default, {
        form: form,
        onSubmit: this._handleSubmit
      }, /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "Username",
        sectionId: "forgotPasswordForm"
      }), oktaMessage ? /*#__PURE__*/_react.default.createElement(_Message.default, {
        type: oktaMessage.type,
        title: oktaMessage.title
      }, oktaMessage.body) : /*#__PURE__*/_react.default.createElement(_FormErrorSummary.default, {
        form: form
      }), triggerSecretQuestionForm && showPasswordRecoveryForm && this._renderGenericFormForPasswordRecovery(), !successfullTransaction && /*#__PURE__*/_react.default.createElement("div", {
        className: "btn-holder"
      }, additionalButtons, /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: "button",
        type: "submit",
        disabled: isBusy
      }, submitBtnText))));
    } //endregion

  }]);

  return ForgotPasswordForm;
}(_react.default.Component);

exports.default = ForgotPasswordForm;

_defineProperty(ForgotPasswordForm, "propTypes", {
  /**
   * Mulesoft identity base url
   */
  identityBaseUrl: _propTypes.default.string.isRequired,

  /**
   * Form initilisation hook
   */
  onInitilise: _propTypes.default.func,

  /**
   * Submit button text
   */
  submitBtnText: _propTypes.default.string,

  /**
   * Success message
   */
  successMessage: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),

  /**
   * Cancel button text
   */
  additionalButtons: _propTypes.default.node,

  /**
   * Okta Environment
   */
  oktaEnv: _propTypes.default.string,

  /**
   * Portal Identifier to choose email template
   */
  portalIdentifier: _propTypes.default.string,

  /**
   * unknown user recovery error message
   */
  unknownUserRecoveryErrorMessage: _propTypes.default.object,

  /**
   * error messages provided from particular portal
   */
  errMessages: _propTypes.default.arrayOf(_propTypes.default.shape({
    errTitle: _propTypes.default.string.isRequired,
    errMessage: _propTypes.default.string.isRequired
  })),

  /**
   * Trigger Secret Question Form
   */
  triggerSecretQuestionForm: _propTypes.default.string,

  /**
   * Success message secret question
   */
  successMessageSecretQuestion: _propTypes.default.string
});

_defineProperty(ForgotPasswordForm, "defaultProps", {
  onInitilise: function onInitilise(config) {
    return config;
  },
  submitBtnText: 'Send',
  successMessage: /*#__PURE__*/_react.default.createElement("p", null, "A password reset link has been emailed to your accounts designated email address."),
  additionalButtons: null,
  oktaEnv: null,
  portalIdentifier: null,
  unknownUserRecoveryErrorMessage: {
    title: 'There was an issue.',
    body: 'Please try again shortly. If the issue persists, please contact us.'
  },
  errMessages: [],
  triggerSecretQuestionForm: false,
  successMessageSecretQuestion: /*#__PURE__*/_react.default.createElement("p", null, "Thank you for submitting your details. icare will contact you shortly regarding your account access.")
});
//# sourceMappingURL=ForgotPasswordForm.js.map